import * as React from 'react';
import { Input } from 'antd';
import { default as styled } from 'styled-components';
import {
  blueColor,
  blueOpacityColor,
  lightBlackColor,
  orangeColor,
  weightGreyColor,
  whiteColor,
  borderColor,
  contentFontColor,
  lightGreyColor
} from '@config/index';

export const NiInput: typeof Input = styled(Input).attrs((props: any) => ({
  className: 'ni-input'
}))`

  &.ant-input,
  &.ant-input-affix-wrapper {
    /* margin-bottom: 20px; */
    padding-top:6px;
    background-color: ${whiteColor};
    border-radius: 6px;
    border: 1px solid ${borderColor};
    color: ${contentFontColor};

    &:focus {
      border: 1px solid ${blueColor};
      box-shadow: 0 0 1px 2px ${blueOpacityColor} !important;
    }

    &.primary {
      background-color: ${weightGreyColor};
    }

    &.error {
      border: 1px solid ${orangeColor};
    }

    &.border-bottom {
      border: 0;
      border-radius: 0;
      border-bottom: 1px solid ${lightBlackColor};

      &:focus {
        border-bottom: 1px solid ${blueColor};
        box-shadow: 0 2px 2px ${blueOpacityColor} !important ;
      }
    }
  }

  &.input-disabled,
  &.ant-input-affix-wrapper-disabled,
  &.ant-input[disabled] {
    background-color: ${weightGreyColor};
  }

` as any;
